/*
 * Copyright (c) 2019.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Vladimir Ganturin <gun2rin@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */


import {Feature} from './Feature';
import {Channel} from './Channel';

export interface Catalog {
  id: number;
  header: string;
  icon?: string;
  syncUid?: string;
  htHead?: string;
  htDesc?: string;
  htKeywords?: string;
  parent?: Catalog;
  features?: Feature[];
  channels?: Channel[];
  parentId?: number;
  content?: string;
  enabled?: boolean;
  disabled?: boolean;
  deleted?: boolean;
  createdAt?: Date;
  updatedAt?: Date;
  lft?: number;
  rgt?: number;
  level?: number;
  lastLevel?: boolean;
  children?: Catalog[];
  productCount?: number;
  pos?: number;
}
